import { debounce } from "../../utils/shared";

export const createSearchBar = (element) => {
  const MOBILE_BREAKPOINT = 768;
  const MIN_SEARCH_LENGTH = 2;

  const instance = {
    $element: null,
    $searchForm: null,
    $searchInput: null,
    $searchButton: null,
    $searchResults: null,
    isOpen: false,
    isMobile: window.innerWidth < MOBILE_BREAKPOINT,

    init(element) {
      this.$element = jQuery(element);
      this.initializeElements();
      this.initializeEventListeners();
    },

    initializeElements() {
      this.$searchForm = this.$element.find(".js-search-form");
      this.$searchInput = this.$element.find(".js-search-input");
      this.$searchButton = this.$element.find(".js-search-button");
      this.$searchResults = this.$element.find(".js-search-results");
    },

    initializeEventListeners() {
      this.$searchInput.on(
        "input",
        debounce(this.handleSearchInput.bind(this), 300)
      );
      this.$searchInput.on("focus", this.handleSearchFocus.bind(this));
      jQuery(document).on("click", this.handleClickOutside.bind(this));
    },

    handleClickOutside(e) {
      if (this.$searchResults.is(":visible")) {
        if (
          !jQuery(e.target).closest(this.$searchForm).length &&
          !jQuery(e.target).closest(this.$searchResults).length &&
          !jQuery(e.target).closest(this.$searchInput).length
        ) {
          this.hideSearchResults();
        }
      }
    },

    handleSearchInput({ target: { value: searchQuery } }) {
      if (searchQuery.length > MIN_SEARCH_LENGTH) {
        this.loading();
        this.showSearchResults();
        this.performAjaxSearch(searchQuery);
      } else {
        this.hideSearchResults();
        this.updateSearchResults("");
      }
    },

    handleSearchFocus() {
      if (this.$searchInput.val().length > MIN_SEARCH_LENGTH) {
        this.showSearchResults();
      }
    },

    async performAjaxSearch(searchQuery) {
      try {
        const response = await jQuery.get(hs.ajaxUrl, {
          action: "hs_search_products",
          search_query: searchQuery,
        });

        this.updateSearchResults(
          response.success ? response.data.html : response.html
        );
      } catch (error) {
        console.error("Search failed:", error);
        this.updateSearchResults('<div class="error">Search failed</div>');
      }
    },

    // UI Methods
    loading() {
      this.updateSearchResults(
        `<div class="hs-search-loading text-sm">${hs.strings.searching}</div>`
      );
    },

    showSearchResults() {
      this.$searchResults.show();
    },
    hideSearchResults() {
      this.$searchResults.hide();
    },

    updateSearchResults(html) {
      this.$searchResults.html(html);
    },

    show() {
      this.isOpen = true;
      this.isMobile ? this.$element.slideDown(100) : this.$element.show();
    },

    hide() {
      this.isOpen = false;
      this.isMobile ? this.$element.slideUp(100) : this.$element.hide();
    },

    toggle() {
      this.isOpen ? this.hide() : this.show();
    },
  };

  instance.init(element);
  return instance;
};
